var map = {
	"./icn-ada.svg": 6777,
	"./icn-ape.svg": 6193,
	"./icn-apt.svg": 8096,
	"./icn-arb.svg": 7384,
	"./icn-atom.svg": 280,
	"./icn-avax.svg": 1421,
	"./icn-base.svg": 424,
	"./icn-blur.svg": 4552,
	"./icn-btc.svg": 3408,
	"./icn-cad.svg": 6757,
	"./icn-canto.svg": 9396,
	"./icn-comp.svg": 4278,
	"./icn-cro.svg": 5719,
	"./icn-crv.svg": 1902,
	"./icn-dot.svg": 6880,
	"./icn-eth.svg": 6508,
	"./icn-ftm.svg": 378,
	"./icn-fuse.svg": 480,
	"./icn-glmr.svg": 8827,
	"./icn-icp.svg": 4205,
	"./icn-kava.svg": 1020,
	"./icn-ldo.svg": 3378,
	"./icn-link.svg": 1683,
	"./icn-matic.svg": 5815,
	"./icn-metis.svg": 2851,
	"./icn-mkr.svg": 7579,
	"./icn-mnt.svg": 8014,
	"./icn-movr.svg": 2891,
	"./icn-near.svg": 2637,
	"./icn-op.svg": 3142,
	"./icn-pepe.svg": 6679,
	"./icn-real.svg": 8103,
	"./icn-scrl.svg": 7927,
	"./icn-sei.svg": 6580,
	"./icn-snx.svg": 2308,
	"./icn-sol.svg": 4427,
	"./icn-sui.svg": 1300,
	"./icn-trx.svg": 7371,
	"./icn-uni.svg": 1811,
	"./icn-usd.svg": 6325,
	"./icn-usdc.svg": 5036,
	"./icn-usdt.svg": 4467,
	"./icn-wld.svg": 8010,
	"./icn-xlm.svg": 2836,
	"./icn-xrp.svg": 2391,
	"./icn-zk.svg": 142
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5877;